export default __webpack_public_path__ + "static/media/General.82fd4144.jpg";